import { render, staticRenderFns } from "./territorieItemData.vue?vue&type=template&id=2d17a62d&scoped=true&"
import script from "./territorieItemData.vue?vue&type=script&lang=js&"
export * from "./territorieItemData.vue?vue&type=script&lang=js&"
import style0 from "./territorieItemData.vue?vue&type=style&index=0&id=2d17a62d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d17a62d",
  null
  
)

export default component.exports